// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2BtpI","newExpiryDate":"styles_newExpiryDate__rzs_6","footer":"styles_footer__2JJoT"};